import type {
    Cents,
    DepositAccount,
    PaymentDate,
    RecurringDetailsRequestDTO,
} from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

export interface PaymentScheduleRenderDetails extends RecurringDetailsRequestDTO {
    fromAccount: DepositAccount;
    toAccount: DepositAccount;
    amount: Cents;
    id: string;
    nextPaymentDate?: PaymentDate;
    metadata?: {
        applyIncomeSplit?: boolean;
    };
}

const useGetPaymentSchedules = requestBuilder.query<
    PaymentScheduleRenderDetails[]
>({
    endpoint: () => '/api/payment-schedules/',
    queryKey: () => 'getPaymentSchedules',
});

export default useGetPaymentSchedules;
